import e from"classnames";import t from"react";const r=r=>{const{children:s,className:a}=r;return t.createElement("div",{className:e("flex justify-center",a)},s)};export{r as default};
//# sourceMappingURL=CarouselItem.js.map
